const ctx = (() => {
  const canvas = document.createElement("canvas");
  return canvas.getContext("2d");
})();

const measureCache = new Map();
const measure = (text, font) => {
  const key = `${font}|${text}`;
  const cached = measureCache.get(key);
  if (cached !== undefined) return cached;
  ctx.font = font;
  const width = ctx.measureText(String(text ?? "")).width;
  measureCache.set(key, width);
  return width;
};

/**
 * Largest font size (between `min` and `max`) where `text` fits inside
 * `maxWidth` x `maxHeight`, wrapping if it must.
 */
export const computeFitFontSize = (
  text,
  maxWidth,
  maxHeight,
  {
    min = 5,
    max = 12,
    step = 0.25,
    fontFamily = "Helvetica, Arial, sans-serif",
    lineHeight = 1.15,
  } = {},
) => {
  if (!text || !maxWidth || !maxHeight) return max;
  const str = String(text);

  for (let size = max; size >= min; size -= step) {
    const w = measure(str, `${size}px ${fontFamily}`);
    if (w <= maxWidth) return size;

    const charsPerLine = Math.max(1, Math.floor((maxWidth / w) * str.length));
    const lines = Math.ceil(str.length / charsPerLine);
    if (lines * size * lineHeight <= maxHeight) return size;
  }
  return min;
};
